const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user suspended display directive to manage edits on user objects
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('suspendedDisplay', ['Application', 'Authorization', 'Users', '$translate', function (Application, Authorization, Users, $translate) {
    return {
      restrict: 'E',
      scope: {},
      replace: true,
      template: require('../../templates/directives/suspended-display.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        $scope.referenceUser = {};
        self.currentMainTab = 'general';
        self.loading = false;

        self.initialize = function () {
          var routeParameters = Application.navigation.getRouteParameters();
          if (!routeParameters.id) {
            Application.notifications.setError(self.translations['modules.notifications.invalidUrl']);
            Application.navigation.goTo('overview/users');
            return;
          }
          if (Authorization.getAuthToken().user._id.toString() !== routeParameters.id.toString() && Authorization.getAuthToken().user.role !== 'admin') {
            Application.navigation.goTo('/explore');
          }
          var userFields = '_id,first_name,last_name,email,job_title,job_type,role,language,image,department,last_login,createdAt,notes,hired,linked_locations,linked_departments,is_manager,manager_email';
          Users.suspended({_id: routeParameters.id, fields: userFields}).$promise
          .then(function(results) {
            if (!results || !results[0]) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['suspendedDisplay.user_not_found']});
              Application.navigation.goTo('#/overview/users');
              return;
            }
            var user = results[0];
            user.formattedLastLogin = moment(user.last_login).format("MMM Do YY");
            self.user = user;
            self.lastLogin = self.user.last_login ? moment(new Date(self.user.last_login)).format('MMMM Do YYYY') : '----';
            self.created = self.user.createdAt ? moment(new Date(self.user.createdAt)).format('MMMM Do YYYY') : '----';
          });
        };

        $translate([
          'modules.notifications.invalidUrl',
          'modules.notifications.user_couldNotBeSaved',
          'modules.notifications.user_saved',
          'manage.users.creator',
          'manage.users.external',
          'manage.users.administrator',
          'manage.users.user',
          'manage.users.department',
          'manage.users.location',
          'manage.users.selectALocation',
          'suspendedDisplay.user_not_found'
        ]).then(function(data){
          self.translations = data;
          self.initialize();
        });

      }],
      controllerAs: 'editor'
    };
  }]);
